export const components = {
    Default: {
        porlet: 'Porlet/PorletFormulario.vue',
        porlethorizontal: 'Porlet/PorletFormularioHorizontal.vue',
        datatable: 'Porlet/PorletTableElement.vue',
        Grafica: 'Porlet/PorletGrafica.vue',
        Documentos: 'Porlet/PorletDocumentos.vue',
        Informes: 'Porlet/PorletInformes.vue',
        Actividad: 'Porlet/PorletActividad.vue',
        Chat: 'Chat/components/Chat.vue',
        Comentarios: 'Porlet/PorletComentarios.vue',
        Iframe: 'Porlet/PorletIframe.vue',
        MenuHeader: 'Porlet/PorletMenuHeader.vue',
        MenuSearch: 'Porlet/PorletMenuSearch.vue',
        MenuActions: 'Porlet/PorletMenuActions.vue',
        Calendar: 'Porlet/PorletCalendar.vue',
        InfoBox: 'Porlet/PorletInfoBox.vue',
        Label: 'Porlet/PorletLabel.vue',
        Buscador: 'Porlet/PorletBuscador.vue',
        Cuadromando: 'Porlet/PorletBuscadorCuadroMando.vue',
        OpenDrawerRight: 'Porlet/PorletOpenDrawerRight.vue',
        OpenDrawerLeft: 'Porlet/PorletOpenDrawerLeft.vue',
        GestorDocumental: 'Dms/GestorDocumental.vue',
        VisorDocumental: 'Dms/VisorDocumental.vue',
        BusquedasGuardadas: 'Dms/BusquedasGuardadas.vue',
        ADM: 'Dms/ADM.vue',
        TASK: 'Dms/TASK.vue',
        NAV: 'Dms/NAV.vue',
        Cabecera: 'Porlet/PorletCabecera.vue',
        HookCustom: 'Porlet/PorletHookCustom.vue',
        Columnas: 'Porlet/PorletColumnas.vue',
        Calendario: 'Porlet/PorletCalendario.vue',
        VisorPDF: 'Porlet/PorletVisorPDF.vue',
        VisorOCR: 'Porlet/PorletVisorOCR.vue',
        Listado: 'Porlet/PorletListado.vue',
        Form: 'Porlet/PorletForm.vue',
        Dashboard: 'Porlet/PorletDashboard.vue',
        DashboardDOOX: 'Porlet/PorletDashboardDOOX.vue',
        Compiled: 'Porlet/PorletCompiled.vue',
        ControlTrabajo: 'Porlet/PorletControlTrabajo.vue',
        HookCustomRemote: 'Porlet/PorletHookCustomRemote.vue',
        MapaAlmacen: 'Porlet/PorletMapaAlmacen',
        Tree: 'Porlet/PorletTree',
        Central: 'Porlet/PorletCentral',
        GDS: 'Porlet/PorletGDS',
        Link: 'Porlet/PorletLink.vue',
    },
    Tema1: {
        porlet: 'Porlet/PorletFormulario.vue'
    },
    Metronic: {
        Cabecera: 'Porlet/PorletCabecera.vue',
    }
}